import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    payFormRow: {
        marginTop: 15
    }
};
